function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { CustomInput } from "reactstrap";
import _ from "lodash";
import { AvGroup } from "availity-reactstrap-validation";
import TmLabel from "./components/TmLabel";
import TmFeedback from "./components/TmFeedback";
import TmHelpMessage from "./components/TmHelpMessage";

class TmRadioGroupInput extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderRadios", () => {
      const {
        field,
        fieldGroup,
        inline,
        onChange,
        value
      } = this.props;
      return _.map(this.props.options, option => {
        const label = !!option.label ? option.label : option;
        const name = !!fieldGroup ? `${fieldGroup.replace(/\w+/g, _.capitalize)}[${_.camelCase(field)}]` : _.camelCase(field);
        return /*#__PURE__*/React.createElement(CustomInput, {
          type: "radio",
          className: 'no-error-label',
          name: name,
          id: `${name}__${_.camelCase(label)}`,
          key: `${name}__${_.camelCase(label)}`,
          label: label,
          value: !!option.label ? option.value : option,
          inline: inline,
          onChange: onChange,
          defaultChecked: !!option.label ? option.value === value : option === value
        });
      });
    });

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(AvGroup, null, /*#__PURE__*/React.createElement(TmLabel, _extends({
        className: 'no-error-label'
      }, this.props)), /*#__PURE__*/React.createElement("div", null, this.renderRadios()), /*#__PURE__*/React.createElement(TmFeedback, this.props), /*#__PURE__*/React.createElement(TmHelpMessage, this.props));
    });
  }

}

export default TmRadioGroupInput;